import { fetchPermission } from "../../api/index"
import router, { DynamicRoutes } from "../../router/index"
import dynamicRoutes from "../../router/dynamic-router"
import { recursionRouter, setDefaultRoute } from "../../utils/recursion-router"

function uniqueArrayByKey(array, key = 'key') {
  const map = new Map()
  array.forEach(item => map.set(item[key], item))
  return Array.from(map.values())
}

export default {
  namespaced: true,
  state: {
    infoObj: {},
    infoRouter: [],
    infoRouterShow: true,
    permissionList: null,
    sidebarMenu: [],
    currentMenu: "",
    layoutRouter: "",
    tenantId: "",
    isCollapse: false,
    recordRoutes: [],
  },
  mutations: {
    INFO_OBJ(state, item) {
      state.infoObj = item
    },
    SET_PERMISSION(state, routes) {
      state.permissionList = routes
    },
    CLEAR_PERMSSION(state) {
      state.permissionList = null
    },
    SET_MENU(state, menu) {
      state.sidebarMenu = menu;
    },
    CLEAR_MENU(state) {
      state.sidebarMenu = []
    },
    USER_PARAMETER(state, menu) {
      state.infoRouter = menu
    },
    FOR_ROUTER(state, routes) {
      if (!routes.name) return
      state.layoutRouter = routes.name
      state.currentMenu = routes.name
      state.infoRouterShow = true

      const tabItem = {
        name: routes.meta?.name || routes.name,
        key: routes.name,
        fullPath: routes.fullPath,
      }

      // 从本地读取
      let localTabs = localStorage.getItem("tabAlwaysRouter")
      state.recordRoutes = localTabs ? uniqueArrayByKey(JSON.parse(localTabs)) : []

      const isExist = state.recordRoutes.some(item => item.key === tabItem.key)
      if (!isExist) {
        state.recordRoutes.push(tabItem) // ✅ 修复：tab → tabItem

        if (!routes.fullPath.includes("?")) {
          localStorage.setItem("tabAlwaysRouter", JSON.stringify(state.recordRoutes))
        }
      }
    },
    COLLAPSE_IS(state, show) {
      state.isCollapse = show
    },
    CLEAR_TABS(state) {
      state.recordRoutes = []
      localStorage.removeItem("tabAlwaysRouter")
    }
  },

  actions: {
    async FETCH_PERMISSION({ commit, state }) {
      const userInfo = JSON.parse(localStorage.getItem("info") || "{}")
      if (!userInfo) return
      commit("INFO_OBJ", userInfo)

      const MainContainer = DynamicRoutes.find(v => v.path === "")
      if (!MainContainer) return
      const { children } = MainContainer

      const allRoutes = [...children, ...dynamicRoutes]
      let finalRoutes = []

      // 管理员
      if (userInfo.username === "admin") {
        finalRoutes = allRoutes.map(item => {
          item.show = true
          if (item.children) {
            item.children = item.children.map(c => {
              c.show = true
              return c
            })
          }
          return item
        })
      }

      // 普通用户
      else {
        const pathList = userInfo.managerRoleResource?.split(";") || []
        commit("USER_PARAMETER", pathList)

        function filterAllRoutes(routes, names) {
          return routes.map(route => {
            const newRoute = { ...route }
            newRoute.show = names.includes(route.name)
            if (newRoute.children) {
              newRoute.children = filterAllRoutes(newRoute.children, names)
            }
            return newRoute
          })
        }
        finalRoutes = filterAllRoutes(allRoutes, pathList)
      }

      children.length = 0
      children.push(...finalRoutes)
      commit("SET_MENU", children)

      setDefaultRoute([MainContainer])
      const initialRoutes = router.options.routes
      router.addRoutes([MainContainer])
      commit("SET_PERMISSION", [...initialRoutes, ...DynamicRoutes])
    }
  }
}